import type { ComponentProps } from 'react'

import { cn } from '../../lib/utils'

export const Input = ({ className, ref, ...props }: ComponentProps<'input'>) => (
  <input
    ref={ref}
    className={cn(
      [
        'border-input bg-background text-foreground flex h-10 min-h-10 w-full rounded-lg border px-3 py-2 text-sm',
        'shadow-sm shadow-black/[0.04] dark:border-white/12 dark:shadow-black/25',
        'placeholder:text-muted-foreground placeholder:opacity-100',
        'transition-[border-color,box-shadow,background-color] duration-200 ease-out',
        'motion-reduce:transition-[border-color,background-color]',
        'hover:border-ring/35 dark:hover:border-ring/45',
        'focus-visible:border-ring dark:focus-visible:border-ring/80 focus-visible:outline-none',
        'motion-safe:focus-visible:shadow-[0_1px_2px_0_rgba(0,0,0,0.04),0_0_0_3px_hsl(var(--ring)_/_0.2),0_10px_28px_-12px_hsl(var(--ring)_/_0.18)]',
        'dark:motion-safe:focus-visible:shadow-[0_0_0_3px_hsl(var(--ring)_/_0.28),0_12px_32px_-14px_hsl(var(--ring)_/_0.22)]',
        'motion-reduce:focus-visible:shadow-none',
        'file:text-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'touch-manipulation',
      ],
      className,
    )}
    {...props}
  />
)
Input.displayName = 'Input'
